const TagList = (props) => {
  const { data } = props;

  return (
    <>
      {data.map((item) => {
        return (
          <li key={item.name} className="tag-item text-overflow">
            {item.name}
          </li>
        );
      })}
    </>
  );
};

export default TagList;
